import { Component, inject, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RouteReplayDataService } from '../../services/route-replay-data.service';
import { Subscription } from 'rxjs';
import { RouteReplayService } from '../../services/route-replay.service';
import { ToastService } from 'mis-crystal-design-system/toast';

@Component({
  selector: 'app-route-replay',
  templateUrl: './route-replay.component.html',
  styleUrl: './route-replay.component.scss'
})
export class RouteReplayComponent implements OnInit, OnDestroy {
  private activatedRoute = inject(ActivatedRoute);
  private routeReplayDataService = inject(RouteReplayDataService);
  private routeReplayService = inject(RouteReplayService);
  private toast = inject(ToastService);
  
  private subscriptions: Subscription[] = [];
  
  routeId: string = '';
  routeIds: string[] = [];
  isMultiRoute: boolean = false;
  date: string = '';
  shift: string = '';
  buid: string = '';
  source: string = '';
  isLoading: boolean = false;

  ngOnInit(): void {
    // Get query params
    const queryParams = this.activatedRoute.snapshot.queryParams;
    this.date = queryParams['date'] || '';
    this.shift = queryParams['shift'] || '';
    this.buid = queryParams['buid'] || '';
    this.source = queryParams['source'] || '';
    
    // Get routeIds from query parameter (comma-separated, works for single or multiple)
    const routeIdsParam = queryParams['routeIds'];
    
    if (!routeIdsParam) {
      this.toast.displayMsg("No routes specified!");
      return;
    }
    
    this.routeIds = routeIdsParam.split(',');
    this.isMultiRoute = this.routeIds.length > 1;

    // Update service with buid
    if (this.buid) {
      this.routeReplayDataService.updateBuid(this.buid, this.source);
    }

    // Load route replay data using bulk API
    this.loadRouteReplayData();
  }

  loadRouteReplayData(): void {
    this.isLoading = true;

    // Use bulk API for both single and multiple routes
    const sub = this.routeReplayService
      .getBulkRouteReplayData(this.routeIds)
      .subscribe({
        next: () => {
          this.isLoading = false;
        },
        error: (error) => {
          console.error('Error loading route replay data:', error);
          this.toast.displayMsg(this.isMultiRoute ? "Error While Fetching Routes Data!" : "Error While Fetching Vehicles Data!");
          this.isLoading = false;
        }
      });
    this.subscriptions.push(sub);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }
}
